// External link / new tab
export const DEFAULT_OPEN_IN_NEW_TAB_TEXT = 'opens in a new window';

// Navigation arrows
export const DEFAULT_NEXT_TEXT = 'Next';
export const DEFAULT_PREVIOUS_TEXT = 'Previous';
export const DEFAULT_NEXT_TABS_TEXT = 'Next tabs';
export const DEFAULT_PREVIOUS_TABS_TEXT = 'Previous tabs';

// Modal / dialog
export const DEFAULT_CLOSE_DIALOG_TEXT = 'Close dialog';

// Truncation / expand-collapse
export const DEFAULT_SEE_MORE_TEXT = 'See More';
export const DEFAULT_SEE_LESS_TEXT = 'See Less';

// Accordion expand / collapse
export const DEFAULT_EXPAND_TEXT = 'Expand';
export const DEFAULT_COLLAPSE_TEXT = 'Collapse';
export const DEFAULT_EXPAND_ALL_TEXT = 'Expand All';
export const DEFAULT_COLLAPSE_ALL_TEXT = 'Collapse All';

// Carousel
export const DEFAULT_CAROUSEL_LABEL = 'Image gallery';
export const DEFAULT_SLIDE_LABEL = 'Slide {x} of {y}';
export const DEFAULT_GALLERY_BUTTON_TEXT = 'Gallery';
export const DEFAULT_VIRTUAL_TOUR_BUTTON_TEXT = 'Virtual Tour';

// Video
export const DEFAULT_VIDEO_ARIA_LABEL = 'Video';
export const DEFAULT_PAUSE_VIDEO_LABEL = 'Pause video';
export const DEFAULT_PLAY_VIDEO_LABEL = 'Play video';
export const DEFAULT_VIDEO_ERROR_MESSAGE = 'Unable to load video';
